var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60039 4.93805L8.94039 1.97805C10.0804 1.33805 11.9404 1.33805 13.0904 1.97805L18.4304 4.94805C19.6404 5.61805 20.6304 7.29805 20.6304 8.67805V14.328C20.6304 15.708 19.6404 17.388 18.4304 18.058C16.6404 19.048 14.8804 20.188 13.0204 21.028C11.7604 21.598 10.1904 21.718 8.94039 21.028L3.60039 18.058C2.39039 17.388 1.40039 15.708 1.40039 14.328V8.66805C1.40039 7.28805 2.39039 5.60805 3.60039 4.93805Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0098 20.568V11.498",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20996 6.38818L11.04 11.4982L19.81 6.41818",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4202 13.5583L14.3302 12.4683L13.2402 13.5583",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3301 17.4279V12.6079",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeightIcon);
export default __webpack_public_path__ + "static/media/height-icon.312e01b819d9cfee079c174c0d0237a0.svg";
export { ForwardRef as ReactComponent };